var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.279 2.703a2.399 2.399 0 00-3.807.555L7.03 7.776 3.304 9.26a.8.8 0 00-.27 1.308l2.633 2.633-3.432 3.433L2 18l1.365-.234 3.433-3.433 2.633 2.633a.8.8 0 001.308-.268l1.492-3.73 4.511-2.44a2.399 2.399 0 00.555-3.806l-4.018-4.02z",
    fill: "var(--secondary-yellow-500)"
  })));
}
export default SvgPinned;